import React, { useState, useEffect } from "react";
import axios from "axios";
import { Certificate } from "@fidm/x509";
import moment from "moment";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { IconButton } from "@mui/material";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";

export default function UserDetailsModal({ user }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [certInfo, setCertInfo] = useState([]);
  const [name, setName] = useState("");
  const [san, setSan] = useState("");
  const [orgUnit, setOrgUnit] = useState("");
  const [issName, setIssName] = useState("");
  const [org, setOrg] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [publicKey, setPublicKey] = useState("");

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_ADMIN_CERT_URL}/${user.email}`)
      .then((res) => {
        const data = res.data;
        const cert = Certificate.fromPEM(data.certificate);
        console.log(cert.publicKey._finalKey);
        setPublicKey(cert.publicKey._finalKey);
        setCertInfo(cert);
        setSan(cert.dnsNames[0]);
        setName(cert.subject.attributes[1].value);
        setOrgUnit(cert.subject.attributes[0].value);
        setIssName(cert.issuer.attributes[4].value);
        setOrg(cert.issuer.attributes[3].value);
        setCountry(cert.issuer.attributes[0].value);
        setState(cert.issuer.attributes[1].value);
        setCity(cert.issuer.attributes[2].value);
      });
  }, []);

  return (
    <div>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{
          backgroundColor: "#ffd900",
          "&:hover": { backgroundColor: "#ffd900" },
        }}
        startIcon={<RemoveRedEyeIcon />}
      >
        Details
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal">
          <div className="flex justify-between bg-[#ec644c]  align-baseline">
            <h3 className="text-gray-700 text-2xl mt-1 ml-2">User's Details</h3>
            <IconButton onClick={handleClose}>
              <CloseSharpIcon />
            </IconButton>
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div className="requests-display">
              <div className="request-details-container">
                <div className="bg-[#808080]">
                  <h3 className="text-white text-lg mt-1 ml-2">
                    Basic Information
                  </h3>
                </div>
                <TableContainer component={Paper}>
                  <Table aria-label="user info table">
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Username
                        </TableCell>
                        <TableCell>{user.username}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Account ID
                        </TableCell>
                        <TableCell>{user.id}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Email
                        </TableCell>
                        <TableCell>{user.email}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Role
                        </TableCell>
                        <TableCell>{user.attributes?.role || "-"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Type
                        </TableCell>
                        <TableCell>{user.attributes?.type || "-"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Requested
                        </TableCell>
                        <TableCell>
                          {moment(user.createdTimestamp).format(
                            "DD-MM-YYYY HH:mm:ss"
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Public Key
                        </TableCell>
                        <TableCell>{publicKey}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <div className="bg-[#808080]">
                  <h3 className="text-white text-lg mt-1 ml-2">Subject</h3>
                </div>
                <TableContainer component={Paper}>
                  <Table aria-label="subject info table">
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Common name
                        </TableCell>
                        <TableCell>{name}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          SAN
                        </TableCell>
                        <TableCell>{san}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Organization Unit
                        </TableCell>
                        <TableCell>{orgUnit}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <div className="bg-[#808080]">
                  <h3 className="text-white text-lg mt-1 ml-2">Issuer</h3>
                </div>
                <TableContainer component={Paper}>
                  <Table aria-label="issuer info table">
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Common name
                        </TableCell>
                        <TableCell>{issName}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Organization
                        </TableCell>
                        <TableCell>{org}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Country
                        </TableCell>
                        <TableCell>{country}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          State
                        </TableCell>
                        <TableCell>{state}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          City
                        </TableCell>
                        <TableCell>{city}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
